import { render, staticRenderFns } from "./AddTipotelefonePage.vue?vue&type=template&id=0cd4a008"
import script from "./AddTipotelefonePage.vue?vue&type=script&lang=js"
export * from "./AddTipotelefonePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports